const env = process.env.ENVIRONMENT !== "PDN" ? "DEV" : "PDN"

const siteUrl =
  process.env.ENVIRONMENT === "PDN"
    ? process.env.SITE_URL
    : process.env.ENVIRONMENT === "STG"
      ? process.env.SITE_STG
      : process.env.SITE_DEV

// TODO: pendiente ajustar id de actividad
export const competitionId = {
  DEV: 81,
  PDN: 81
}[env] //Id Game Tren del Loving
export const countryActivity = { name: "Colombia", contact: "018000 052 48 48" }
export const costActivity = 20
export const timesActivity = {
  inicio: { dia: 26, mes: "Enero", año: 2022 },
  fin: { dia: 26, mes: "Febrero", año: 2022},
  ganadoras: { dia: "7 y 11", mes: "Marzo", año: 2022}
}
export const numWinners = 50

export const activitySEO = {
  url:
    env === "LOCAL" ? "" : `${siteUrl}/magazin/concursos/v-match`,
  title: `Encuentra la pareja`,
  description: `Un juego con tus productos favoritos Nosotras para que pongas a prueba tu memoria, ganes premios y te diviertas.`
}

// export const secondsLimitGame = 30
export const delayFlip = 500
export const pointsByMatch = 5
export const timeForLevels = [
  30,
  50,
  70,
  90,
  110
]

export const matrixGame = {
  mobile: {
    0: [
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0]
    ],
    1: [
      [0, 0, 0, 0],
      [1, 1, 1, 1],
      [0, 0, 0, 0]
    ],
    2: [
      [0, 1, 1, 0],
      [0, 1, 1, 0],
      [0, 1, 1, 0]
    ],
    3: [
      [1, 1, 1, 1],
      [1, 1, 1, 1],
      [0, 0, 0, 0]
    ],
    4: [
      [1, 1, 1, 1],
      [1, 1, 1, 1],
      [0, 1, 1, 0]
    ],
    5: [
      [1, 1, 1, 1],
      [1, 1, 1, 1],
      [1, 1, 1, 1]
    ]
  },
  desktop: {
    0: [
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0]
    ],
    1: [
      [0, 0, 0, 0],
      [1, 1, 1, 1],
      [0, 0, 0, 0]
    ],
    2: [
      [0, 1, 1, 0],
      [0, 1, 1, 0],
      [0, 1, 1, 0]
    ],
    3: [
      [1, 1, 1, 1],
      [1, 1, 1, 1],
      [0, 0, 0, 0]
    ],
    4: [
      [1, 1, 1, 1],
      [1, 1, 1, 1],
      [0, 1, 1, 0]
    ],
    5: [
      [1, 1, 1, 1],
      [1, 1, 1, 1],
      [1, 1, 1, 1]
    ]
  }
}

export const imgProducts = [
  require("./../assets/images/game/img1.png"),
  require("./../assets/images/game/img2.png"),
  require("./../assets/images/game/img3.png"),
  require("./../assets/images/game/img4.png"),
  require("./../assets/images/game/img5.png"),
  require("./../assets/images/game/img6.png")
]
